import { useEffect, useState } from 'react';

import { getLinkedSocialIdentities, type LinkedSocialIdentity } from '@/lib/logto';

/**
 * Fetch the user's Logto-linked social identities once (userinfo `oidc/me`).
 * Returns `null` while loading, then a map keyed by connector target
 * (`google`, `apple`, `discord`, `twitch`, …). Telegram is NOT included — it is
 * not a Logto connector; read it from `useTelegram().user`.
 */
export function useLinkedIdentities(): Record<string, LinkedSocialIdentity> | null {
  const [identities, setIdentities] = useState<Record<string, LinkedSocialIdentity> | null>(
    null,
  );

  useEffect(() => {
    let active = true;
    void getLinkedSocialIdentities().then((r) => {
      if (active) setIdentities(r);
    });
    return () => {
      active = false;
    };
  }, []);

  return identities;
}
